/*
 * Ported from the legacy app's scripts/app/components/search.js.
 *
 * Only the global nav-search form handlers are kept (still used by
 * frSearchPage). The legacy club-search AJAX block (gated behind
 * `.page-club-search`, which no longer exists in any in-scope view) has been
 * dropped as dead code during the Phase 4 migration.
 */

(function ($) {

    $(function () {
        var body = $('body');

        //
        // SEARCH PAGE
        //
        body.on('click', '.nav-search-submit',
            function () {
                var searchQuery = $('.nav-search-text').val();
                var searchUrl = $(this).attr('data-url');
                if (searchQuery) {
                    body.addClass('searching');
                    window.location.href = searchUrl + '?query=' + searchQuery;
                }
            });
        body.on('click', '.nav-search-btn',
            function () {
                body.addClass('searching');
            });

        // The "searching" class is only ever added right before a full-page navigation to the search
        // results page, never removed on this page itself. If the user then clicks the browser back
        // button, the browser can restore this page from the back/forward cache (bfcache) exactly as
        // it was when they left - "searching" class and all - without firing a fresh load/DOMContentLoaded,
        // so the spinner is stuck until a manual reload. `pageshow` fires on both normal loads and
        // bfcache restores; `event.persisted` tells them apart.
        $(window).on('pageshow', function (e) {
            var originalEvent = e.originalEvent || e;
            if (originalEvent && originalEvent.persisted) {
                body.removeClass('searching');
            }
        });



        body.on('keypress', '.nav-search-text', function (e) {
            if (e.which === 13) {
                $('.nav-search-submit').trigger('click');
                return false;
            }
            return true;
        });
    });

})(window.jQuery);
